import type { GQL_ID } from '@@partner:types:graphql'
import type {
  UpdateOrderProductMutation,
  UpdateOrderProductMutationVariables
} from '@@partner:graphql/mutation/order/updateOrderProduct.gql'

import { useMemo, useCallback } from 'react'
import { useMutation } from '@apollo/client'
import debounce from 'awesome-debounce-promise'

import { GQL_MUTATION_UPDATE_ORDER_PRODUCT } from '@@partner:graphql/mutation/order/updateOrderProduct.gql'

export default function useOrderProduct (order_id: GQL_ID) {
  const [ updateOrderProductGQL, { loading } ] = useMutation<
    UpdateOrderProductMutation,
    UpdateOrderProductMutationVariables
  >(GQL_MUTATION_UPDATE_ORDER_PRODUCT)

  const updateOrderProduct = useCallback(
    (product_id: GQL_ID, amount: number) =>
      updateOrderProductGQL({
        variables: {
          order_id,
          orderProduct: {
            product_id,
            amount
          }
        }
        // fetchPolicy: 'network-only'
      }),
    [ order_id, updateOrderProductGQL ]
  )

  const updateOrderProductDebounced = useMemo(
    () =>
      debounce(
        (product_id: GQL_ID, amount: number) =>
          updateOrderProduct(product_id, amount),
        500,
        { onlyResolvesLast: true }
      ),
    [ updateOrderProduct ]
  )

  return {
    loading,
    updateOrderProduct: updateOrderProductDebounced,
    deleteOrderProduct: (product_id: GQL_ID) =>
      updateOrderProduct(product_id, 0)
  }
}
